import Column from "@Containers/components/Column";
import TripDetails from "@CheckOrder/components/Title/TripDetails";
import React from "react";
import {useAppSelector} from "@Hooks/selector/useAppSelector";

type TripDetailsContainerProps = {}

function TripDetailsContainer(props: TripDetailsContainerProps) {
    const {
        singleRoute,
        returnRoute,
        companies,
    } = useAppSelector((state) => state.checkOrder.purchasedRoute)

    return (
        <Column className="gb--card" style={{margin: '-1rem 1rem 1rem 1rem', boxShadow: 'unset'}}>
            <TripDetails
                departureStation={singleRoute.travelInfo.departureStation}
                destinationStation={singleRoute.travelInfo.destinationStation}
                logoUrl={companies[singleRoute.companyId]?.logoUrl}
                companyId={singleRoute.companyId}
            />
            {returnRoute && (
                <>
                    <hr/>
                    <TripDetails
                        departureStation={returnRoute.travelInfo.departureStation}
                        destinationStation={returnRoute.travelInfo.destinationStation}
                        logoUrl={companies[returnRoute.companyId]?.logoUrl}
                        companyId={returnRoute.companyId}
                    />
                </>
            )}
        </Column>
    );
}

export default TripDetailsContainer;